import { INACCESSIBLE_COMPONENTS } from '@wix/a11y-rules';
import { Text, TextButton, Timeline } from '@wix/design-system';
import { Trans, useTranslation } from '@wix/fe-essentials/react';
import { ElementStatus } from '@wix/rules-panel-ui';
import React from 'react';
import { AddElements } from '../../../../assets/illustrations/add-elements';
import { BiCtaNames, generalToolTips } from '../../../../bi/types';
import { useA11yWizardAdapter } from '../../../../hooks/use-a11y-wizard-adapter';
import { useBiLogger } from '../../../../hooks/use-bi-logger';
import { useOpenArticleByEditorHost } from '../../../../hooks/use-open-article-by-editor-host';
import { InaccessibleComponentI18nKeys } from './translation-keys';
export const ElementWithContent = _ref => {
  let {
    element,
    elementIndex,
    status,
    kbArticleKey,
    handleRescanClick
  } = _ref;
  const {
    t
  } = useTranslation();
  const biLogger = useBiLogger();
  const {
    editorHost
  } = useA11yWizardAdapter();
  const {
    openSelectedArticle
  } = useOpenArticleByEditorHost();
  const getFirstStep = () => {
    if (element.type === INACCESSIBLE_COMPONENTS.OldForm.componentType) {
      return firstStepWixForm;
    }
    return firstStep;
  };
  const isReinstallComponent = !!element.reinstall;
  const i18nKeys = isReinstallComponent ? InaccessibleComponentI18nKeys.reinstall : InaccessibleComponentI18nKeys.alternative;
  const firstStep = /*#__PURE__*/React.createElement(Text, {
    size: "tiny"
  }, /*#__PURE__*/React.createElement(Trans, {
    components: {
      componentName: /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        weight: "bold"
      })
    },
    i18nKey: i18nKeys.firstStep,
    values: {
      label: element.label
    }
  }));
  const firstStepWixForm = /*#__PURE__*/React.createElement(Text, {
    size: "tiny"
  }, t('accessibility-wizard.rules-list.inaccessible-components.old-form.first-step'));
  const secondStep = /*#__PURE__*/React.createElement(Text, {
    size: "tiny"
  }, /*#__PURE__*/React.createElement(Trans, {
    components: {
      addElements: /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        weight: "bold"
      }),
      alternativeComponent: /*#__PURE__*/React.createElement(Text, {
        size: "tiny",
        weight: "bold"
      }),
      learnMore: /*#__PURE__*/React.createElement(TextButton, {
        as: "a",
        size: "tiny",
        skin: "dark",
        target: "_blank",
        underline: "always",
        onClick: () => {
          openSelectedArticle(editorHost, kbArticleKey);
          biLogger.taskElementCtaClick({
            ctaName: BiCtaNames.LearnMore,
            index: elementIndex,
            status: status ? ElementStatus.ManualPassed : ElementStatus.ManualFailed
          });
        }
      }),
      plus: /*#__PURE__*/React.createElement(AddElements, null)
    },
    i18nKey: i18nKeys.secondStep,
    values: {
      componentName: t(`accessibility-wizard.rules-list.inaccessible-components.alternative.${element.alternateComponent}`)
    }
  }));
  const thirdStep = /*#__PURE__*/React.createElement(Text, {
    size: "tiny"
  }, /*#__PURE__*/React.createElement(Trans, {
    components: {
      rescanButton: /*#__PURE__*/React.createElement(TextButton, {
        size: "tiny",
        skin: "dark",
        underline: "always",
        weight: "bold",
        onClick: () => {
          handleRescanClick(element.id);
          biLogger.taskElementCtaClick({
            ctaName: generalToolTips.rescanPage,
            index: elementIndex,
            status: status ? ElementStatus.ManualPassed : ElementStatus.ManualFailed
          });
        }
      })
    },
    i18nKey: InaccessibleComponentI18nKeys.rescanStep
  }));
  const items = [{
    label: getFirstStep()
  }, {
    label: secondStep
  }, {
    label: thirdStep
  }];
  return /*#__PURE__*/React.createElement(Timeline, {
    gap: "20px",
    items: items,
    skin: "dark"
  });
};
//# sourceMappingURL=element-with-content.js.map